export const environment = {
  features: {
    fastTrack: true,
  },
  allowIframe: true,
  allowedOrigins: [
    'http://localhost:4200',
    'http://localhost:4300',
    'https://esg-risk-dev-referral.gfitdnsdev.swissre.com',
    'https://pcbpm-dev1.swissreapps-np.com',
  ],
  apiUrl: 'https://esg-risk-dev-api.gfitdnsdev.swissre.com/api',
  adminApiUrl: 'https://esg-risk-dev-admin-api.gfitdnsdev.swissre.com/api',
  // adminApiUrl: 'http://localhost:8080/api',
  esgReferralLink: 'https://esg-risk-dev-referral.gfitdnsdev.swissre.com',
  // apiUrl: 'http://localhost:8080/api',
  applicationInsightsKey: 'cd06aedf-24d8-4326-a453-b0c9760af4f7',
  msalConfig: {
    clientId: '91aa6f14-d47a-44e1-8097-cf248b21a571',
    authority: 'https://login.microsoftonline.com/45597f60-6e37-4be7-acfb-4c9e23b261ea',
    scope: 'api://52c98c3f-cdba-41cd-b212-b9f023c3df6e/AllApi',
    adminScope: 'api://25fd23d4-98db-4af4-b9ca-d2afff7642ee/AdminAPI',
  },
  catNet: {
    baseUrl: 'https://dev.catnet.swissre.com',
    activeLayers: 'GEOPORTAL:ESG_PROTECTED_AREA_GLOBAL_202509',
    initialMapBounds: '-260.6235538,-74.0163168,282.1889462,85.0511288',
  },
  cixApiUrl: 'https://stargate.swissre.com',
  cixMatchedCompanyQueryPath: '/api/v2/ontologies/default/queries/matchedCompanyStartsWith/execute',
  cixOidc: {
    authority: 'https://stargate.swissre.com/multipass',
    clientId: '56a0ff49f8b7b04d982309b9c70b409b',
    redirectUri: `${window.location.origin}/cix-auth/callback`,
    scope: 'api:ontologies-read offline_access',
    silentRedirectUri: `${window.location.origin}/cix-auth/callback`,
  },
  insightsApiUrl: 'https://stargate.swissre.com',
  insightsOntology: 'ontology-swissre-dev',
  insightsActionPath: '/api/v2/ontologies/{ontology}/actions/esginsight-create-control-record/apply',
  insightsQueryPath: '/api/v2/ontologies/{ontology}/queries/getEsgRecommendation/execute',
  insightsOidc: {
    authority: 'https://stargate.swissre.com/multipass',
    clientId: 'c7ff760b8c6e9845ee89f83eb0343cda',
    redirectUri: `${window.location.origin}/insights-auth/callback`,
    scope: 'api:ontologies-read api:ontologies-write offline_access',
    silentRedirectUri: `${window.location.origin}/insights-auth/callback`,
  },
};
